<template>
  <div class="nx-list-page safety-culture-page">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      :before-open="beforeOpen"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="handleRowAdd"
        >
          新增
        </el-button>
        <el-upload
          class="inline-upload"
          action=""
          :show-file-list="false"
          :http-request="handleImport"
          accept=".xls,.xlsx"
        >
          <el-button
            type="primary"
            size="small"
            plain
            icon="el-icon-upload2"
            :loading="importLoading"
          >
            导入
          </el-button>
        </el-upload>
        <el-button
          type="default"
          size="small"
          plain
          icon="el-icon-document"
          @click="handleDownloadImportTemplate"
        >
          导入模板
        </el-button>
        <el-button
          type="primary"
          size="small"
          plain
          icon="el-icon-download"
          :loading="exportLoading"
          @click="handleExport"
        >
          导出
        </el-button>
      </template>

      <template slot="completeStatus" slot-scope="{ row }">
        <el-tag :type="Number(row.completeStatus) === 1 ? 'success' : 'warning'">
          {{ completeStatusText(row.completeStatus) }}
        </el-tag>
      </template>

      <template slot="imageMaterials" slot-scope="{ row }">
        <div v-if="parseImageMaterials(row.imageMaterials).length" class="image-list">
          <el-image
            v-for="(img, index) in parseImageMaterials(row.imageMaterials)"
            :key="index"
            class="image-thumb"
            :src="img"
            :preview-src-list="parseImageMaterials(row.imageMaterials)"
            fit="cover"
          />
        </div>
        <span v-else>-</span>
      </template>

      <template slot="menu" slot-scope="{ row, size, index }">
        <el-button
          type="text"
          :size="size"
          icon="el-icon-view"
          @click="handleView(row, index)"
        >
          查看
        </el-button>
        <el-button
          type="text"
          :size="size"
          icon="el-icon-edit"
          @click="handleEdit(row, index)"
        >
          编辑
        </el-button>
        <el-button
          type="text"
          :size="size"
          icon="el-icon-check"
          @click="handleComplete(row)"
        >
          {{ Number(row.completeStatus) === 1 ? '补充图片' : '完成' }}
        </el-button>
        <el-button
          type="text"
          :size="size"
          icon="el-icon-delete"
          class="danger-text"
          @click="rowDel(row)"
        >
          删除
        </el-button>
      </template>
    </avue-crud>

    <el-dialog
      title="完成安全文化"
      :visible.sync="completeVisible"
      width="680px"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="resetCompleteForm"
    >
      <el-form
        ref="completeForm"
        :model="completeForm"
        :rules="completeRules"
        label-width="100px"
      >
        <el-form-item label="主题">
          <span>{{ completeForm.theme || '-' }}</span>
        </el-form-item>
        <el-form-item label="完成日期" prop="completeDate">
          <el-date-picker
            v-model="completeForm.completeDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择完成日期"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="图片资料" prop="imageMaterials">
          <avue-form
            ref="completeImageForm"
            v-model="completeImageForm"
            :option="completeImageOption"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="completeVisible = false">取消</el-button>
        <el-button type="primary" :loading="completeLoading" @click="submitComplete">
          保存完成状态
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins'
import { initDataTime, numSeparator } from '@/basic-common/util/common'
import { desensitizationDispose } from '@/basic-common/util/desensitization'
import { downloadXls } from '@/util/util'
import {
  getList,
  getDetail,
  add,
  update,
  complete,
  remove,
  downloadImportTemplate,
  importExcel,
  exportExcel,
  getDeptTree,
  uploadEndpoint,
} from './api'

const statusDic = [
  { label: '未完成', value: 0 },
  { label: '已完成', value: 1 },
]

export default {
  name: 'DispatchSafetyCultureIndex',
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList, getDetail, add, update, remove },
      exportLoading: false,
      importLoading: false,
      completeVisible: false,
      completeLoading: false,
      completeForm: {
        id: '',
        theme: '',
        completeDate: '',
      },
      completeImageForm: {
        imageMaterials: '',
      },
      completeRules: {
        completeDate: [{ required: true, message: '请选择完成日期', trigger: 'change' }],
      },
      completeImageOption: {
        ...this.$store.state.formOption,
        submitBtn: false,
        emptyBtn: false,
        labelWidth: 0,
        column: [
          {
            label: '',
            prop: 'imageMaterials',
            type: 'upload',
            multiple: true,
            drag: true,
            action: uploadEndpoint,
            propsHttp: { res: 'data', url: 'link' },
            dataType: 'string',
            listType: 'picture-card',
            tip: '图片资料非必传，支持多张上传',
            span: 24,
          },
        ],
      },
      option: {
        ...this.$store.state.publicOption,
        menu: true,
        menuWidth: 260,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        dialogWidth: '760px',
        dialogClickModal: false,
        column: [
          {
            label: '主题',
            prop: 'theme',
            search: true,
            searchSpan: 6,
            minWidth: 180,
            overHidden: true,
            rules: [
              { required: true, message: '请输入主题', trigger: 'blur' },
              { max: 100, message: '主题长度不能超过100个字符', trigger: 'blur' },
            ],
          },
          {
            label: '内容',
            prop: 'content',
            type: 'textarea',
            minRows: 4,
            maxlength: 2000,
            showWordLimit: true,
            span: 24,
            minWidth: 220,
            overHidden: true,
            rules: [{ required: true, message: '请输入内容', trigger: 'blur' }],
          },
          {
            label: '计划日期',
            prop: 'planDate',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            search: true,
            searchRange: true,
            searchSpan: 8,
            paramsKey: ['startPlanDate', 'endPlanDate'],
            minWidth: 120,
            rules: [{ required: true, message: '请选择计划日期', trigger: 'change' }],
          },
          {
            label: '完成日期',
            prop: 'completeDate',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            minWidth: 120,
          },
          {
            label: '组织部门',
            prop: 'organizeDeptId',
            type: 'tree',
            dicData: [],
            props: {
              label: 'deptName',
              value: 'id',
            },
            search: true,
            searchSpan: 6,
            minWidth: 140,
            overHidden: true,
            rules: [{ required: true, message: '请选择组织部门', trigger: 'change' }],
            change: ({ value }) => this.handleDeptChange(value),
          },
          {
            label: '组织部门名称',
            prop: 'organizeDeptName',
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: '完成状态',
            prop: 'completeStatus',
            type: 'select',
            dicData: statusDic,
            props: {
              label: 'label',
              value: 'value',
            },
            dataType: 'number',
            search: true,
            searchSpan: 6,
            minWidth: 100,
            slot: true,
            value: 0,
          },
          {
            label: '图片资料',
            prop: 'imageMaterials',
            type: 'upload',
            multiple: true,
            drag: true,
            action: uploadEndpoint,
            propsHttp: { res: 'data', url: 'link' },
            dataType: 'string',
            listType: 'picture-card',
            tip: '图片资料非必传，支持多张上传',
            slot: true,
            span: 24,
            minWidth: 160,
            hide: true,
          },
        ],
      },
    }
  },
  created() {
    this.loadDeptOptions()
  },
  methods: {
    loadDeptOptions() {
      getDeptTree().then(({ data }) => {
        const deptColumn = this.findObject(this.option.column, 'organizeDeptId')
        deptColumn.dicData = (data && data.data) || data || []
      })
    },
    handleDeptChange(value) {
      const deptColumn = this.findObject(this.option.column, 'organizeDeptId')
      const dept = this.findDeptById(deptColumn.dicData || [], value)
      this.$set(this.form, 'organizeDeptName', dept ? dept.deptName : '')
    },
    findDeptById(list, id) {
      for (let i = 0; i < list.length; i += 1) {
        const item = list[i]
        if (String(item.id) === String(id)) return item
        const children = item.children || item.childList || []
        const result = this.findDeptById(children, id)
        if (result) return result
      }
      return null
    },
    onLoad(page, params = {}) {
      if (this.initstate) {
        this.initstate = false
        return
      }
      this.queryData = this.formatParams(Object.assign({}, this.defaultParams, params, this.query))
      this.loading = true
      const requestParams = {
        ...this.queryData,
        current: page.currentPage,
        size: page.pageSize,
      }
      getList(requestParams).then((res) => {
        const pageData = (res.data && res.data.data) || {}
        this.responseData = pageData.records || []
        this.page.total = pageData.total || 0
        this.responseData = initDataTime(this.responseData, this.option.column)
        this.data = numSeparator(this.responseData, this.option, 'list')
        this.data = desensitizationDispose(this.data, 'list')
        this.cardData = pageData
      }).finally(() => {
        this.loading = false
        this.$nextTick(() => {
          if (this.option && !this.option.cancelHijack && this.$refs.crud) {
            this.$refs.crud.getTableHeight && this.$refs.crud.getTableHeight()
            this.$refs.crud.doLayout && this.$refs.crud.doLayout()
          }
        })
      })
    },
    beforeOpen(done, type) {
      this.openType = type
      if (type === 'add') {
        this.form = {
          theme: '',
          content: '',
          planDate: '',
          completeDate: '',
          organizeDeptId: '',
          organizeDeptName: '',
          completeStatus: 0,
          imageMaterials: '',
        }
        done()
        return
      }
      if (['edit', 'view'].includes(type) && this.form.id) {
        getDetail(this.form.id).then((res) => {
          this.form = this.toFormData((res.data && res.data.data) || res.data || {})
          done()
        })
        return
      }
      done()
    },
    rowSave(row, done, loading) {
      add(this.toSubmitData(row)).then(() => {
        this.$message.success('新增成功')
        this.onLoad(this.page, this.query)
        done()
      }).catch(() => {
        loading()
      })
    },
    rowUpdate(row, index, done, loading) {
      update(this.toSubmitData(row)).then(() => {
        this.$message.success('更新成功')
        this.onLoad(this.page, this.query)
        done()
      }).catch(() => {
        loading()
      })
    },
    rowDel(row) {
      this.$confirm('确定删除该安全文化记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        remove(row.id).then(() => {
          this.$message.success('删除成功')
          this.onLoad(this.page, this.query)
        })
      }).catch(() => {})
    },
    handleRowAdd() {
      if (this.$refs.crud && this.$refs.crud.rowAdd) {
        this.$refs.crud.rowAdd()
      }
    },
    handleView(row, index) {
      this.form = { ...row }
      this.$refs.crud && this.$refs.crud.rowView(row, index)
    },
    handleEdit(row, index) {
      this.form = { ...row }
      this.$refs.crud && this.$refs.crud.rowEdit(row, index)
    },
    handleComplete(row) {
      const imageValue = this.imageMaterialsToUploadValue(row.imageMaterials)
      this.completeForm = {
        id: row.id,
        theme: row.theme,
        completeDate: row.completeDate || '',
      }
      this.completeImageForm = {
        imageMaterials: imageValue,
      }
      this.completeVisible = true
    },
    submitComplete() {
      this.$refs.completeForm.validate((valid) => {
        if (!valid) return
        this.completeLoading = true
        complete({
          id: this.completeForm.id,
          completeDate: this.completeForm.completeDate,
          imageMaterials: this.uploadValueToImageMaterials(this.completeImageForm.imageMaterials),
        }).then(() => {
          this.$message.success('保存成功')
          this.completeVisible = false
          this.onLoad(this.page, this.query)
        }).finally(() => {
          this.completeLoading = false
        })
      })
    },
    resetCompleteForm() {
      this.completeLoading = false
      this.completeForm = {
        id: '',
        theme: '',
        completeDate: '',
      }
      this.completeImageForm = {
        imageMaterials: '',
      }
      this.$nextTick(() => {
        this.$refs.completeForm && this.$refs.completeForm.clearValidate()
      })
    },
    async handleExport() {
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        downloadXls(res.data, `安全文化_${Date.now()}.xlsx`)
        this.$message.success('导出成功')
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '导出失败')
      } finally {
        this.exportLoading = false
      }
    },
    async handleDownloadImportTemplate() {
      try {
        const res = await downloadImportTemplate()
        downloadXls(res.data, `安全文化导入模板_${Date.now()}.xlsx`)
        this.$message.success('模板下载成功')
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '模板下载失败')
      }
    },
    async handleImport({ file }) {
      if (!file) return
      const fileName = file.name || ''
      if (!/\.(xls|xlsx)$/i.test(fileName)) {
        this.$message.error('仅支持 xls、xlsx 文件')
        return
      }
      this.importLoading = true
      try {
        const res = await importExcel(file)
        const msg = (res.data && (res.data.msg || res.data.data)) || '导入成功'
        this.$message.success(msg)
        this.onLoad(this.page, this.query)
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '导入失败')
      } finally {
        this.importLoading = false
      }
    },
    completeStatusText(value) {
      const item = statusDic.find(status => Number(status.value) === Number(value))
      return item ? item.label : '-'
    },
    toFormData(row) {
      return {
        ...row,
        completeStatus: row.completeStatus == null ? 0 : Number(row.completeStatus),
        imageMaterials: this.imageMaterialsToUploadValue(row.imageMaterials),
      }
    },
    toSubmitData(row) {
      return {
        ...row,
        completeStatus: row.completeStatus == null ? 0 : Number(row.completeStatus),
        imageMaterials: this.uploadValueToImageMaterials(row.imageMaterials),
      }
    },
    parseImageMaterials(value) {
      if (!value) return []
      if (Array.isArray(value)) return value.map(item => this.getImageUrl(item)).filter(Boolean)
      if (typeof value !== 'string') return []
      try {
        const parsed = JSON.parse(value)
        if (Array.isArray(parsed)) {
          return parsed.map(item => this.getImageUrl(item)).filter(Boolean)
        }
      } catch (e) {
        // 兼容 Avue 上传回填的逗号分隔 URL。
      }
      return value.split(',').map(item => item.trim()).filter(Boolean)
    },
    getImageUrl(item) {
      if (!item) return ''
      if (typeof item === 'string') return item
      return item.link || item.url || item.value || ''
    },
    imageMaterialsToUploadValue(value) {
      return this.parseImageMaterials(value).join(',')
    },
    uploadValueToImageMaterials(value) {
      const list = this.parseImageMaterials(value)
      return list.length ? JSON.stringify(list) : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.inline-upload {
  display: inline-block;
  margin-left: 8px;
}

.image-list {
  display: flex;
  align-items: center;
  gap: 6px;
  overflow: hidden;
}

.image-thumb {
  width: 42px;
  height: 42px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}

.danger-text {
  color: #f56c6c;
}
</style>
